<template>
  <div class="app-main-inner">
    <div class="app-main-page" style="height: calc(100vh - 100px);align-items: stretch">
      <div style="display: flex;flex:1;height: 100%">
        <div style="display:flex;flex-direction:column;flex:1;height:auto;border:1px solid #ccc;">
          <div class="app-main-inner-row">
            <div>
              <el-form :inline="true" label-width="80px" label-position="left">
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_BusinessType') + ':'">
                    <cargo-advance-select
                      :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
                      :static-options="lobs"
                      :show-custom-label-in-option="true"
                      :default-value="queryData.lob"
                      style="width: 200px"
                      @parentCallBack="lobChangeHandler"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SystemMaintenance.BusinessMode') + ':'">
                    <cargo-advance-select
                      :disabled="!queryData.lob"
                      filterable
                      callback-method-type="value"
                      :static-options="operateTypeList"
                      :default-value="queryData.operateType"
                      tag-name="chineseName"
                      tag-value="code"
                      style="width:200px;"
                      @parentCallBack="onOperateTypeChange"
                    />
                  </el-form-item>
                  <el-form-item label-width="100px" :label="$t('CargoMsg.Cargo_CustomJobType') + ':'">
                    <cargo-advance-select
                      :disabled="!queryData.lob"
                      :select-type="selectTypeNames.basic_data_CutomJobType"
                      filterable
                      :method-params="{type:queryData.lob, active: true}"
                      :default-value="queryData.customJobType"
                      style="width: 200px"
                      @parentCallBack="p=>{queryData.customJobType=p.value}"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode') + ':'">
                    <cargo-advance-select
                      v-if="isSea||isAir"
                      :disabled="!queryData.lob"
                      :select-type="selectTypeNames.basic_data_Region"
                      filterable
                      :default-value="queryData.region"
                      tag-name="code"
                      style="width: 200px"
                      @parentCallBack="p=>{queryData.region=p.value}"
                    />
                    <cargo-advance-select
                      v-else
                      :disabled="!queryData.lob"
                      :select-type="selectTypeNames.basic_data_RailwayLine"
                      filterable
                      :default-value="queryData.region"
                      tag-name="code"
                      style="width: 200px"
                      @parentCallBack="p=>{queryData.region=p.value}"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SystemMaintenance.AirlineChineseName') + ':'">
                    <cargo-advance-select
                      v-if="isSea||isAir"
                      :disabled="!queryData.lob"
                      :select-type="selectTypeNames.basic_data_Region"
                      filterable
                      :default-value="region2"
                      tag-name="name"
                      style="width: 200px"
                      @parentCallBack="p=>{region2=p.value}"
                    />
                    <cargo-advance-select
                      v-else
                      :disabled="!queryData.lob"
                      :select-type="selectTypeNames.basic_data_RailwayLine"
                      filterable
                      :default-value="region2"
                      tag-name="name"
                      style="width: 200px"
                      @parentCallBack="p=>{region2=p.value}"
                    />
                  </el-form-item>
                  <el-form-item>
                    <template>
                      <span v-if="isAir" slot="label">{{ $t('SeaExport.LoadingPort') }}:</span>
                      <span v-else-if="isRailway" slot="label">{{ $t('CargoMsg.Cargo_DepartureStation') }}:</span>
                      <span v-else slot="label">{{ $t('CargoMsg.Cargo_POL') }}:</span>
                    </template>
                    <template>
                      <cargo-advance-select
                        v-if="isSea||isAir"
                        :disabled="!queryData.lob"
                        :select-type="isSea?selectTypeNames.basic_data_Seaport:selectTypeNames.basic_data_Airport"
                        filterable
                        :callback-params="{key:'loadingPortCode'}"
                        :default-value="queryData.loadingPortCode"
                        style="width: 200px"
                        @parentCallBack="setQueryData"
                      />
                      <cargo-advance-select
                        v-else
                        :disabled="!queryData.lob"
                        :select-type="selectTypeNames.basic_data_RailwayStation"
                        filterable
                        :callback-params="{key:'loadingPortCode'}"
                        :default-value="queryData.loadingPortCode"
                        style="width: 200px"
                        @parentCallBack="setQueryData"
                      />
                    </template>
                  </el-form-item>
                  <el-form-item>
                    <template>
                      <span v-if="isAir" slot="label">{{ $t('queryJob.portOfDestination') }}:</span>
                      <span v-else-if="isRailway" slot="label">{{ $t('CargoMsg.Cargo_DestinationStation') }}:</span>
                      <span v-else slot="label">{{ $t('queryJob.dischargingPortCode') }}:</span>
                    </template>
                    <template>
                      <cargo-advance-select
                        v-if="isSea||isAir"
                        :disabled="!queryData.lob"
                        :select-type="isSea?selectTypeNames.basic_data_Seaport:selectTypeNames.basic_data_Airport"
                        filterable
                        :callback-params="{key:'code'}"
                        :default-value="queryData.code"
                        style="width: 200px"
                        @parentCallBack="setQueryData"
                      />
                      <cargo-advance-select
                        v-else
                        :disabled="!queryData.lob"
                        :select-type="selectTypeNames.basic_data_RailwayStation"
                        filterable
                        :callback-params="{key:'code'}"
                        :default-value="queryData.code"
                        style="width: 200px"
                        @parentCallBack="setQueryData"
                      />
                    </template>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_DestinationAgent') + ':'">
                    <cargo-advance-select
                      filterable
                      :disabled="!isSeAe"
                      tag-name="englishName"
                      options-width="150px;"
                      :select-type="selectTypeNames.basic_data_Company"
                      :method-params="{overseaAgent:true}"
                      :default-value="queryData.destinationAgent || ''"
                      style="width: 200px"
                      @parentCallBack="p=>{queryData.destinationAgent=p.value}"
                    />
                  </el-form-item>
                  <el-form-item label-width="100px" :label="$t('SystemMaintenance.RelatedUser') + ':'">
                    <cargo-advance-select
                      :select-type="selectTypeNames.basic_data_User"
                      :callback-params="{key:'userId'}"
                      callback-method-type="value"
                      :default-value="queryData.userId"
                      filterable
                      style="width: 200px"
                      @parentCallBack="setQueryData"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SystemMaintenance.OperationPosition') + ':'">
                    <el-select v-model="queryData.role" filterable clearable style="width: 200px">
                      <el-option v-for="(item,index) in allRole" :key="index" :label="item.name" :value="item.code" />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.opOffice') + ':'">
                    <cargo-advance-select
                      :select-type="selectTypeNames.basic_data_Office_All"
                      filterable
                      :static-options="officeList"
                      :default-value="queryData.opOffice"
                      tag-name="code"
                      style="width: 200px"
                      @parentCallBack="p=>{queryData.opOffice=p.value}"
                    />
                  </el-form-item>
                  <el-form-item label-width="80px" :label="$t('SeaExport.CargoType') + ':'">
                    <cargo-advance-select
                      :select-type="selectTypeNames.basic_data_CargoType"
                      :method-params="isAir?{air:true}:{sea:true}"
                      :disabled="!queryData.lob"
                      filterable
                      :default-value="queryData.cargoType"
                      style="width: 200px"
                      @parentCallBack="p=>{queryData.cargoType=p.value}"
                    />
                  </el-form-item>
                  <el-form-item label-width="80px" :label="$t('CargoMsg.Cargo_Carrier') + ':'">
                    <cargo-company-select
                      v-if="queryData.lob === 'SE'"
                      :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                      :default-value="queryData.carrierId"
                      custom-style="width: 200px"
                      @change="p=>{queryData.carrierId=p.value}"
                    />
                    <cargo-company-select
                      v-else-if="queryData.lob === 'SI'"
                      :method-params="{companyLob:'seaImport',seaCmp:true,active:true}"
                      :default-value="queryData.carrierId"
                      custom-style="width: 200px"
                      @change="p=>{queryData.carrierId=p.value}"
                    />
                    <cargo-company-select
                      v-else-if="queryData.lob === 'AE'"
                      :method-params="{companyLob:'airExport',airCmp:true,active:true}"
                      :default-value="queryData.carrierId"
                      custom-style="width: 200px"
                      @change="p=>{queryData.carrierId=p.value}"
                    />
                    <cargo-company-select
                      v-else-if="queryData.lob === 'AI'"
                      :method-params="{companyLob:'airImport',airCmp:true,active:true}"
                      :default-value="queryData.carrierId"
                      custom-style="width: 200px"
                      @change="p=>{queryData.carrierId=p.value}"
                    />
                    <cargo-company-select
                      v-else-if="queryData.lob === 'IE' && queryData.operateType === 'IC'"
                      :method-params="{companyLob:'integratedJob',truckCmp:true,active:true}"
                      :default-value="queryData.carrierId"
                      custom-style="width: 200px"
                      @change="p=>{queryData.carrierId=p.value}"
                    />
                    <el-select v-else disabled value placeholder=" " style="width: 200px" />
                  </el-form-item>
                  <el-form-item label-width="0">
                    <el-button type="primary" @click="loadUserPort(1)">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
                    <el-button type="primary" @click="addUserPortClickEvent">{{ $t('CargoMsg.Cargo_add') }}</el-button>
                    <el-button type="primary" @click="editUserPortClickEvent">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
                    <el-button type="danger" style="margin-right: 20px" @click="delUserPortClickEvent">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
                    <el-checkbox :value="config.value==='1'" style="margin-right: 20px" @input="onConfigInput">{{ $t('SystemMaintenance.ConfigApplyRemoteBooking') }}</el-checkbox>
                    <el-checkbox :value="manualSelectIfMultipleConfig.value==='1'" style="margin-right: 20px" @input="onManualSelectIfMultipleConfigInput">{{ $t('SystemMaintenance.NotSetDefaultValueMultiPosition') }}</el-checkbox>
                    <el-checkbox :value="notUpdateConfig.value==='1'" @input="onNotUpdateConfigInput">{{ $t('SystemMaintenance.BusinessDataNotUpdate') }}</el-checkbox>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
          <cargo-ag-grid
            config-module="2022082204"
            :column-defs="port.columnDefs"
            :row-data="port.rowData"
            :grid-options="port.gridOptions"
            style="width: 100%;flex-grow:1"
            @gridReady="onReady"
          />
          <div class="pagination-wrapper">
            <cargo-pagination
              config-module="2022082204"
              :total="queryData.total"
              :page-count="queryData.pageCount"
              :page.sync="queryData.pageNum"
              :limit.sync="queryData.pageSize"
              @pagination="()=>{if(queryData.total>0){loadUserPort()}}"
            />
          </div>
        </div>
      </div>
    </div>

    <add-user-port-window
      ref="addUserPortWindow"
      :visible="addUserPort.visible"
      :action="addUserPort.action"
      @cancelHandler="addCancelHandler"
      @saveSuccessHandler="saveSuccessHandler"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import AddUserPortWindow from '@/views/cargo/v0/SystemMaintenance/components/user/addUserPortWindow'
import { batchDeleteUserPortFunc, getUserPortByUserIdAndCodeFunc } from '@/api/userPort'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import $store from '@/store'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { SE, SI, AE, AI, RE, RI } from '@/class/cargo/model/parameters/SystemConstants'
import { getCacheListByKey, getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import { getOfficeConfigByName, saveOfficeConfigFunc } from '@/api/user'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CustomLableUtils from '@/utils/CustomLabelUtils'

export default {
  name: 'UserPortTab',
  components: { AddUserPortWindow, cargoAdvanceSelect, cargoCompanySelect },
  data() {
    const roleList = [
      { code: 'userDefinedRole1', name: this.$t('CargoMsg.Cargo_userDefinedRole1') },
      { code: 'userDefinedRole2', name: this.$t('CargoMsg.Cargo_userDefinedRole2') },
      { code: 'userDefinedRole3', name: this.$t('CargoMsg.Cargo_userDefinedRole3') },
      { code: 'userDefinedRole4', name: this.$t('CargoMsg.Cargo_userDefinedRole4') },
      { code: 'userDefinedRole5', name: this.$t('CargoMsg.Cargo_userDefinedRole5') },
      { code: 'userDefinedRole6', name: this.$t('CargoMsg.Cargo_userDefinedRole6') },
      { code: 'userDefinedRole7', name: this.$t('CargoMsg.Cargo_userDefinedRole7') },
      { code: 'overseaOp', name: this.$t('CargoMsg.Cargo_CustomerServiceOverSea') },
      { code: 'siteOp', name: this.$t('SeaExport.FieldOperation') },
      { code: 'doc', name: this.$t('CargoMsg.Cargo_Documents') },
      { code: 'csr', name: this.$t('CargoMsg.Cargo_CustomerService') },
      { code: 'op', name: this.$t('Message.Operation') },
      { code: 'seaLine', name: this.$t('CargoMsg.Cargo_AirlinePerson') }, // 海运
      { code: 'airline', name: this.$t('CargoMsg.Cargo_AirlinePerson') }, // 空运
      { code: 'railwayLine', name: this.$t('CargoMsg.Cargo_AirlinePerson') } // 铁路
    ]
    return {
      selectTypeNames: TYPE_NAMES,
      lobs: [SE, SI, AE, AI, RE, RI],
      fullscreenLoading: false,
      gridApi: null,
      addUserPort: {
        action: 'add',
        visible: false
      },
      queryData: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        pageCount: 0,
        lob: '',
        operateType: '',
        customJobType: '',
        region: '',
        code: '',
        userId: 0,
        role: '',
        opOffice: 0,
        loadingPortCode: '',
        destinationAgent: '',
        cargoType: '',
        carrierId: 0
      },
      region2: '',
      port: {
        columnDefs: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AirlineCode'),
            field: 'multipleRegion',
            width: 100
          },
          {
            headerName: this.$t('SystemMaintenance.AirlineChineseName'),
            field: 'multipleRegionChineseName',
            width: 200,
            valueFormatter: params => this.getMultipleRegionName(params.data),
            filterParams: {},
            filterValueGetter: params => this.getMultipleRegionName(params.data)
          },
          {
            headerName: `${this.$t('SeaExport.dischargingPort')}/${this.$t('queryJob.portOfDestination')}/${this.$t('SeaExport.destinationStation')}/${this.$t('Price.DischargePort')}`,
            field: 'codeEnglishName',
            width: 200,
            valueFormatter: params => this.getPortLabel(params.data, 'code'),
            filterParams: {},
            filterValueGetter: params => this.getPortLabel(params.data, 'code')
          },
          {
            headerName: this.$t('SystemMaintenance.BusinessType'),
            field: 'lob',
            width: 100,
            valueFormatter: (params) => {
              const state = SystemConstants.getCommonState(params.value, SystemConstants.LOBS)
              if (state) {
                return $store.getters.language === 'zh' ? state.chineseName : state.englishName
              } else {
                return this.$t('SystemMaintenance.All')
              }
            }
          },
          {
            headerName: this.$t('SystemMaintenance.BusinessMode'),
            field: 'operateType',
            width: 100,
            valueFormatter: params => this.operateTypeLabelFunc(params.data),
            filterParams: {},
            filterValueGetter: params => this.operateTypeLabelFunc(params.data)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CustomJobType'),
            field: 'multipleCustomJobType',
            width: 200,
            valueFormatter: params => {
              if (params.value) {
                const values = params.value.split(',')
                return Array.from(values, p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', p, 'name')).join(',')
              }
              return ''
            }
          },
          {
            headerName: this.$t('SystemMaintenance.RelatedUser'),
            field: 'userId',
            width: 100,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('SystemMaintenance.OperationPosition'),
            field: 'multipleRole',
            width: 200,
            valueFormatter: (params) => {
              if (params.value) {
                const positionStrs = params.value.split(',')
                const names = []
                for (const positionStr of positionStrs) {
                  const items = positionStr.split('-')
                  const role = roleList.find(p => p.code === items[0])
                  names.push(role ? role.name : '')
                }
                return names.join(',')
              }
              return ''
            }
          }, {
            headerName: this.$t('SeaExport.opOffice'),
            field: 'multipleOpOffice',
            width: 200,
            valueFormatter: params => {
              if (params.value) {
                const values = params.value.split(',')
                return Array.from(values, p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(p), 'code')).join(',')
              }
              return ''
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_POL'),
            field: 'multipleLoadingPortCode',
            width: 200,
            hide: true,
            valueFormatter: params => this.getPortLabel(params.data, 'multipleLoadingPortCode'),
            filterParams: {},
            filterValueGetter: params => this.getPortLabel(params.data, 'multipleLoadingPortCode')
          }, {
            headerName: this.$t('SeaExport.CargoType'),
            field: 'multipleCargoType',
            hide: true,
            valueFormatter: (params) => {
              if (params.value) {
                const values = params.value.split(',')
                return Array.from(values, p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', p, 'chineseName')).join(',')
              }
              return ''
            },
            width: 150
          }, {
            headerName: this.$t('SeaExport.Carrier'),
            field: 'multipleCarrierId',
            width: 200,
            valueFormatter: params => {
              if (params.value) {
                const values = params.value.split(',')
                return Array.from(values, p => CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(p), 'auto_5')).join(',')
              }
              return ''
            }
          }, {
            headerName: this.$t('SeaExport.SolicitationType'),
            field: 'multipleCargoSource',
            width: 200,
            valueFormatter: params => {
              if (params.value) {
                const values = params.value.split(',')
                ColumnUtils.cargoSourceLabelFunction(params.value)
                return Array.from(values, p => ColumnUtils.cargoSourceLabelFunction(p)).join(',')
              }
              return ''
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_DestinationAgent'),
            field: 'multipleDestinationAgent',
            width: 200,
            valueFormatter: params => {
              if (params.value) {
                const values = params.value.split(',')
                return Array.from(values, p => CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(p), 'auto_2')).join(',')
              }
              return ''
            }
          }
        ],
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          context: {
            componentParent: this
          }
        }
      },
      operateTypeList: [],
      seaRegionList: [],
      airRegionList: [],
      config: {},
      manualSelectIfMultipleConfig: {}, // 配置【当条件匹配到多个岗位人员时，不带出默认值，需要手动选择】
      notUpdateConfig: {}, // 配置【更新业务数据时，不自动更新岗位人员】
      defaultOpOffice: 0,
      officeList: []
    }
  },
  computed: {
    isSea() {
      return this.queryData.lob === 'SE' || this.queryData.lob === 'SI'
    },
    isAir() {
      return this.queryData.lob === 'AE' || this.queryData.lob === 'AI'
    },
    isRailway() {
      return this.queryData.lob === 'RE' || this.queryData.lob === 'RI'
    },
    isSeAe() {
      return this.queryData.lob === 'SE' || this.queryData.lob === 'AE'
    },
    allRole() {
      return [
        { code: 'userDefinedRole1', name: this.$t('CargoMsg.Cargo_userDefinedRole1') },
        { code: 'userDefinedRole2', name: this.$t('CargoMsg.Cargo_userDefinedRole2') },
        { code: 'userDefinedRole3', name: this.$t('CargoMsg.Cargo_userDefinedRole3') },
        { code: 'userDefinedRole4', name: this.$t('CargoMsg.Cargo_userDefinedRole4') },
        { code: 'userDefinedRole5', name: this.$t('CargoMsg.Cargo_userDefinedRole5') },
        { code: 'userDefinedRole6', name: this.$t('CargoMsg.Cargo_userDefinedRole6') },
        { code: 'userDefinedRole7', name: this.$t('CargoMsg.Cargo_userDefinedRole7') },
        { code: 'overseaOp', name: this.$t('CargoMsg.Cargo_CustomerServiceOverSea') },
        { code: 'siteOp', name: this.$t('SeaExport.FieldOperation') },
        { code: 'doc', name: this.$t('CargoMsg.Cargo_Documents') },
        { code: 'csr', name: this.$t('CargoMsg.Cargo_CustomerService') },
        { code: 'op', name: this.$t('Message.Operation') },
        { code: this.isSea ? 'seaLine' : (this.isAir ? 'airline' : 'railwayLine'), name: this.$t('CargoMsg.Cargo_AirlinePerson') } // 区分海运/空运/铁路
      ]
    }
  },
  created() {
    this.officeList = getFilterCacheList(TYPE_NAMES.basic_data_Office_All, p => p.officeId !== 1)
  },
  beforeMount() {
    this.loadUserPort()
    this.loadConfig()
    this.loadManualSelectIfMultipleConfig()
    this.loadNotUpdateConfig()
  },
  methods: {
    onReady(params) {
      this.gridApi = params.api
    },
    setQueryData(obj) {
      this.queryData[obj.key] = obj.value
    },
    addCancelHandler() {
      this.addUserPort.visible = false
    },
    saveSuccessHandler(event) {
      this.addUserPort.visible = false
      this.loadUserPort(1)
    },
    loadUserPort(pageNum) {
      if (typeof pageNum === 'number') {
        this.queryData.pageNum = pageNum
      }
      const regionCodes = this.queryData.region ? [this.queryData.region] : []
      if (this.region2) {
        const cacheKey = this.isSea || this.isAir ? TYPE_NAMES.basic_data_Region : TYPE_NAMES.basic_data_RailwayLine
        const obj = getObjectByCache(cacheKey, 'code', this.region2)
        if (obj) {
          const regions = getFilterCacheList(cacheKey, p => p.name === obj.name)
          for (const region of regions) {
            regionCodes.push(region.code)
          }
        }
      }
      const portCodes = this.queryData.code ? [this.queryData.code] : []
      this.fullscreenLoading = getLoading()
      getUserPortByUserIdAndCodeFunc({
        ...this.queryData,
        region: '',
        regions: regionCodes.join(','),
        code: '',
        codes: portCodes.join(',')
      }).then(res => {
        this.port.rowData = res.data.list
        this.queryData.pageNum = res.data.pageNum
        this.queryData.pageSize = res.data.pageSize
        this.queryData.total = Number(res.data.total)
        this.queryData.pageCount = res.data.pages
        this.gridApi.clearFocusedCell() // 清除选中行
        this.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    addUserPortClickEvent() {
      this.addUserPort.action = 'add'
      if (!this.defaultOpOffice) {
        const officeAll = getCacheListByKey(TYPE_NAMES.basic_data_Office_All)
        for (const office of officeAll) {
          if (office.officeId > 1 && (!this.defaultOpOffice || office.officeId < this.defaultOpOffice)) {
            this.defaultOpOffice = office.officeId
          }
        }
      }
      this.$refs.addUserPortWindow.onShow({
        uuid: '',
        userId: 0,
        code: '',
        lob: 'SE',
        operateType: '',
        multipleRegion: '',
        multipleCustomJobType: '',
        relatedPrivilege: true,
        multipleRole: '',
        multipleOpOffice: this.defaultOpOffice + '',
        multipleLoadingPortCode: '',
        multipleCargoType: '',
        multipleCarrierId: '',
        multipleCargoSource: ''
      })
      this.addUserPort.visible = true
    },
    editUserPortClickEvent() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const selectedData = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
      if (!selectedData) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord2'))
        return
      }
      this.addUserPort.action = 'edit'
      this.$refs.addUserPortWindow.onShow(selectedData)
      this.addUserPort.visible = true
    },
    getSelectedItems() {
      return this.gridApi.getSelectedRows()
    },
    delUserPortClickEvent() {
      const list = this.getSelectedItems()
      if (!list || list.length === 0) {
        this.$message.warning(this.$t('Message.PleaseCheckAtLeastOnePieceOfData'))
        return
      }
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToDelete2', [list.length]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.doDeleteUserPort(list)
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    doDeleteUserPort(list) {
      const keys = []
      for (const u of list) {
        keys.push(u.uuid)
      }
      batchDeleteUserPortFunc(keys).then(res => {
        if (res.data) {
          this.$message.success(this.$t('SystemMaintenance.DeleteSuccess2'))
          this.loadUserPort(1)
        }
      })
    },
    operateTypeLabelFunc(data) {
      let text = ''
      if (data.lob && data.operateType) {
        let operateTypes = []
        switch (data.lob) {
          case 'SE':
          case 'RE':
          case 'RI':
            operateTypes = Array.from(SeaExportConstants.CONTAINER_LOAD_TYPES)
            break
          case 'SI':
            operateTypes = ImportConstants._cargoTypeInputList
            break
          case 'AE':
            operateTypes = AirExportConstants.BUSINESS_MODELS
            break
          case 'AI':
            operateTypes = AirExportConstants.BUSINESS_MODELS
            break
        }
        const array = data.operateType.split(',')
        const isZh = $store.getters.language === 'zh'
        for (const item of array) {
          let commonState = null
          if (data.lob === 'AE' || data.lob === 'AI') {
            commonState = CommonState.getStateByCode(operateTypes, Number(item))
          } else {
            commonState = CommonState.getStateByCode(operateTypes, item)
          }
          if (commonState != null) {
            if (isZh) {
              if (text) {
                text = text + ',' + commonState.chineseName
              } else {
                text = commonState.chineseName
              }
            } else {
              if (text) {
                text = text + ',' + commonState.englishName
              } else {
                text = commonState.englishName
              }
            }
          }
        }
      }
      return text
    },
    getMultipleRegionName(data) {
      if (data.multipleRegion) {
        const regions = data.multipleRegion.split(',')
        if (data.lob === 'SE' || data.lob === 'SI' || data.lob === 'AE' || data.lob === 'AI') {
          return Array.from(regions, p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', p, 'name')).join(',')
        } else if (data.lob === 'RE' || data.lob === 'RI') {
          return Array.from(regions, p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayLine, 'code', p, 'name')).join(',')
        }
      }
      return ''
    },
    getPortLabel(data, field) {
      if (data[field]) {
        const codes = data[field].split(',')
        const names = []
        if (data.lob === 'SE' || data.lob === 'SI') {
          for (const item of codes) {
            names.push(ColumnUtils.getPortLabel('code', item, data, 'auto_7'))
          }
        } else if (data.lob === 'AE' || data.lob === 'AI') {
          for (const item of codes) {
            names.push(ColumnUtils.getPortLabel('code', item, data, 'auto_8'))
          }
        } else if (data.lob === 'RE' || data.lob === 'RI') {
          for (const item of codes) {
            names.push(ColumnUtils.getPortLabel('code', item, data, 'auto_railway'))
          }
        }
        return names.length > 0 ? names.join(',') : ''
      }
      return ''
    },
    lobChangeHandler(data) {
      this.queryData.lob = data.value
      this.queryData.operateType = ''
      switch (data.value) {
        case 'SE':
        case 'RE':
        case 'RI':
          this.operateTypeList = Array.from(SeaExportConstants.CONTAINER_LOAD_TYPES)
          break
        case 'SI':
          this.operateTypeList = ImportConstants._cargoTypeInputList
          break
        case 'AE':
          this.operateTypeList = AirExportConstants.BUSINESS_MODELS
          break
        case 'AI':
          this.operateTypeList = AirExportConstants.BUSINESS_MODELS
          break
      }
      if (!['SE', 'AE'].includes(this.queryData.lob)) {
        this.queryData.destinationAgent = ''
      }
      this.queryData.customJobType = ''
      this.queryData.region = ''
      this.region2 = ''
      this.queryData.loadingPortCode = ''
      this.queryData.code = ''
      this.queryData.cargoType = ''
      this.queryData.carrierId = 0
      if (this.isSea) {
        if (this.queryData.role === 'airline' || this.queryData.role === 'railwayLine') {
          this.queryData.role = 'seaLine'
        }
      } else if (this.isAir) {
        if (this.queryData.role === 'seaLine' || this.queryData.role === 'railwayLine') {
          this.queryData.role = 'airline'
        }
      } else {
        if (this.queryData.role === 'seaLine' || this.queryData.role === 'airline') {
          this.queryData.role = 'railwayLine'
        }
      }
    },
    onOperateTypeChange(val) {
      this.queryData.operateType = val
      if (this.queryData.customJobType) {
        this.queryData.customJobType = ''
      } else {
        const cutomJobTypeList = getCacheListByKey(TYPE_NAMES.basic_data_CutomJobType)
        const obj = cutomJobTypeList.find(p => p.type === this.queryData.lob && p.containerLoadType === this.queryData.operateType)
        if (obj) {
          this.queryData.customJobType = obj.code
        }
      }
      if (this.queryData.lob === 'IE') {
        this.queryData.carrierId = 0
      }
    },
    loadConfig() {
      getOfficeConfigByName({ officeId: 1, configName: 'useUserPortRemoteBooking' }).then(res => {
        this.config = res.data
      })
    },
    onConfigInput(val) {
      this.config.value = val ? '1' : '0'
      saveOfficeConfigFunc({
        officeId: this.config.officeId,
        configName: 'useUserPortRemoteBooking',
        configValue: this.config.value,
        overrideable: this.config.overrideable,
        version: this.config.version,
        uuid: this.config.uuid
      }).then(res => {
        this.loadConfig()
      })
    },
    loadManualSelectIfMultipleConfig() {
      getOfficeConfigByName({ officeId: 1, configName: 'useUserPortManualSelectIfMultiple' }).then(res => {
        this.manualSelectIfMultipleConfig = res.data
      })
    },
    onManualSelectIfMultipleConfigInput(val) {
      this.manualSelectIfMultipleConfig.value = val ? '1' : '0'
      saveOfficeConfigFunc({
        officeId: this.manualSelectIfMultipleConfig.officeId,
        configName: 'useUserPortManualSelectIfMultiple',
        configValue: this.manualSelectIfMultipleConfig.value,
        overrideable: this.manualSelectIfMultipleConfig.overrideable,
        version: this.manualSelectIfMultipleConfig.version,
        uuid: this.manualSelectIfMultipleConfig.uuid
      }).then(res => {
        this.loadManualSelectIfMultipleConfig()
      })
    },
    loadNotUpdateConfig() {
      getOfficeConfigByName({ officeId: 1, configName: 'useUserPortNotUpdate' }).then(res => {
        this.notUpdateConfig = res.data
      })
    },
    onNotUpdateConfigInput(val) {
      this.notUpdateConfig.value = val ? '1' : '0'
      saveOfficeConfigFunc({
        officeId: this.notUpdateConfig.officeId,
        configName: 'useUserPortNotUpdate',
        configValue: this.notUpdateConfig.value,
        overrideable: this.notUpdateConfig.overrideable,
        version: this.notUpdateConfig.version,
        uuid: this.notUpdateConfig.uuid
      }).then(res => {
        this.loadNotUpdateConfig()
      })
    }
  }
}
</script>
